import * as React from "react";
import {useGlobalStores} from "../../../../../hooks/use_global_stores";
import {SelectField} from "../../../../Components/Form/SelectField";
import { transformToMuiSelectFormat } from "../../../../../helpers/budget_helpers";
import { ValidationError } from "../../../../../services/validator";

interface IBudgetFieldProps {
    value: string;
    onChange(value: any): void;
    errors?: ValidationError[];
}

export const BudgetField = ({value, onChange, errors}: IBudgetFieldProps) => {
    const { budgetStore } = useGlobalStores();

    const options = transformToMuiSelectFormat(budgetStore.budgets);

    return (
        <SelectField
            label="Budget"
            options={options}
            value={value || ''}
            onChange={onChange}
            optionValueGetter={o => o.value}
            optionLabelGetter={o => o.label}
            errors={errors}
        />
    );
};
